import axios from 'axios'
import Vue from 'vue';

const SpotifyModule = {
	namespaced: true,
	state: {
		baseURL: 'https://api.spotify.com/v1/',
		token: '',
		topTracks: [],
		topArtists: [],
		topAlbums: [],
		artists: [],
		albums: [],
		date: null
	},
	mutations: {
		SET_TOKEN(state, token) {
			state.token = token;
		},
		CREATE_TOP_TRACKS(state, tracks) {
			Vue.set(state, 'topTracks', tracks)
		},
		CLEAR_TOP_TRACKS(state) {
			state.topTracks = [];
		},
		CREATE_TOP_ARTISTS(state, artists) {
			Vue.set(state, 'topArtists', artists)
		},
		CLEAR_TOP_ARTISTS(state) {
			state.topArtists = [];
		},
		CREATE_TOP_ALBUMS(state, albums) {
			Vue.set(state, 'topAlbums', albums);
		},
		CLEAR_TOP_ALBUMS(state) {
			state.topAlbums = [];
		},
		CREATE_FOLLOWED_ARTISTS(state, artists) {
			Vue.set(state, 'artists', artists)
		},
		CONCAT_ARTIST_ALBUMS(state, albums) {
			state.albums = state.albums.concat(albums);
		},
		UPDATE_DATE(state, date) {
			state.date = date
		},
		CLEAR_ALBUMS(state) {
			state.albums = []
		}
	},
	actions: {
		GetLoginURL(_, scopes) {
			let CLIENT_ID = '65aa6828e99d438c92e2ae7dacb8ac23';
			let REDIRECT_URI = 'https://ytbioadb.dennis-kruse.dev/callback';
			
			return 'http://accounts.spotify.com/authorize?client_id=' + CLIENT_ID +
			'&redirect_uri=' + encodeURIComponent(REDIRECT_URI) +
			'&scope=' + encodeURIComponent(scopes.join(' ')) +
			'&response_type=token';
		},
		GetTopItems({state, commit}, payload) {
			if(state.token.length === 0 || !payload?.ranking_type) return;
			const isAlbum = payload.ranking_type === 'albums';
			const type = !isAlbum ? payload.ranking_type : 'tracks'
			const timeRange = payload.time_range || "medium_term"
			const limit = payload.limit || 5

			axios.get(`${state.baseURL}me/top/${type}?time_range=${timeRange}&limit=${limit}&offset=0`,{
				headers: {
					'Authorization': `Bearer ${state.token}`
				}
			}).then(res => {
				commit(`CLEAR_TOP_${payload.ranking_type.toUpperCase()}`)
				let topAlbums = false
				if(isAlbum) {
					topAlbums = []
					let tracks = res.data.items;
					let topAlbumsSort = {}
					const albumtracks = tracks.filter(track => track.album.album_type === 'ALBUM');
					let albums = albumtracks.map(track => track.album)
					for (const key in albums) {
						const album = albums[key]
						if(album) {
							if(!topAlbumsSort[album.id]) {
								topAlbums.push(album)
								topAlbumsSort[album.id] = 1
								continue
							}
							topAlbumsSort[album.id]++
						}   
					}
					topAlbums = topAlbums.sort((a, b) => topAlbumsSort[a.id] - topAlbumsSort[b.id])
					topAlbums.reverse()
				}
				commit(`CREATE_TOP_${payload?.ranking_type.toUpperCase()}`, topAlbums || res.data.items)
			}).catch(err => console.error(err));
		},
		async GetFollowedArtist({state, commit}) {
			if(state.token.length === 0) return;
			let next = `${state.baseURL}me/following?type=artist`;
			let artists = [];
			
			do {
				try {
					const res = await axios.get(next, {headers: {'Authorization': `Bearer ${state.token}`}});
					if(res.status === 200)
						next = res.data.artists.next;
						artists = artists.concat(res.data.artists.items);
				} catch (err) {
					console.error(err);
				}
			} while(next != null);

			commit('CREATE_FOLLOWED_ARTISTS', artists);
		},
		async GetAlbumFromArtist({state, commit}, artist_id) {
			if(state.token?.length === 0 || !artist_id) return;
			let next = `${state.baseURL}artists/${artist_id}/albums?include_groups=album%2Csingle`;

			do {
				try {
					const res = await axios.get(next, {headers: {'Authorization': `Bearer ${state.token}`}});
					if(res.status === 200)
						next = res.data.next;
						commit('CONCAT_ARTIST_ALBUMS', res.data.items);
				} catch (err) {
					console.error(err);
				}
			} while(next != null);
		}
	}
};

export default SpotifyModule
